module.exports = __webpack_public_path__ + "img/ami.9048c439.svg";